export default function About() {
  return (
    <section id="about" className="grid md:grid-cols-2 grid-cols-1 md:gap-10 gap-5 px-6 py-12 items-start">
        <div>
            <div className="flex items-center gap-3">
                <h3 className="text-sm uppercase tracking-wide whitespace-nowrap">
                ABOUT HARVEY
                </h3>
                <div className="h-px w-1/3 bg-[#D07728]/60" />
            </div>

            <h2 className="md:text-4xl text-2xl mt-2">
                Rooted in <span className="text-[#D07728]">Africa</span>,
                <br /> Speaking to the World
            </h2>
            <p className="mt-2 text-[#D07728] md:text-lg text-justify">
                I currently lead the Acts 11 Project at Church Mission Society in Oxford, a study centre for global witness and human migration, and a Masters programme in African Christianity.
            </p>
        </div>
        <div className="md:text-lg text-justify">
          <p className="md:mb-4 mb-2">
            I come from the southern part of Malawi. I am African, and that identity has shaped everything; my theology, my scholarship, my vision for the Church. Having lived and worked across Europe and North America, I carry the unique vantage point of an African missiologist in the old Christian heartland of the West.
          </p>
          <p className="md:mb-4 mb-2">
            My work centres on two great passions: Christian mission in the West - particularly the extraordinary role of migrant Christians in re-evangelising Europe - and the story of African Christianity, both on the continent and in the diaspora.
          </p>
          <p className="md:mb-4 mb-2">
            I am deeply shaped by conversations with Lesslie Newbigin, Andrew Walls, Lamin Sanneh, and above all, John Mbiti, whose work on African Christianity and philosophy continues to animate my own thinking.
          </p>
        </div>
      </section>
  );
}